<template>
  <div class="container" id="forgetPwd">
    <div class="content">
      <div class="wrapper">
        <!-- <Steps :current="current" style="margin-left: 50px;">
          <Step title="手机或邮箱验证"></Step>
          <Step title="修改密码"></Step>
          <Step title="完成"></Step>
        </Steps> -->
        <div class="content-wrapper">
          <!-- <div v-if="current==0">
            <div class="switch" v-show="validMode === 'phone'" @click="validMode='mail'">切换邮箱验证 >> </div>
            <div class="switch" v-show="validMode === 'mail'" @click="validMode='phone'">切换手机验证 >> </div>
            <Form ref="phoneForm" :model="phoneForm" :rules="phoneValidate" :label-width="80">
              <FormItem label="账号" prop="name">
                <Input v-model="phoneForm.name" :disabled="true"></Input>
              </FormItem>
              <FormItem label="手机号码" prop="phone" v-if="validMode === 'phone'">
                <Input v-model="phoneForm.phone" :disabled="true"></Input>
              </FormItem>
              <FormItem label="账号邮箱" prop="mail" v-if="validMode === 'mail'">
                <Input v-model="phoneForm.mail" :disabled="true"></Input>
              </FormItem>
              <FormItem label="验证码" prop="validateNum">
                <Input v-model="phoneForm.validateNum" style="width:200px;margin-right:15px;"></Input>
                <Button type="primary" @click="getVercode" :disabled="codeDisabled">{{codeValidText}}</Button>
              </FormItem>
            </Form>
            <div style="text-align:right">
              <Button type="primary" ghost @click="goLogin" style="margin-right: 16px;">返回登录</Button>
              <Button type="primary" @click="next">下一步</Button>
            </div>
          </div> -->
          <div v-if="current==0">
            <Form ref="passwordForm" :model="passwordForm" :rules="passwordValidate" :label-width="70" style="width:350px;margin:0 auto;">
              <FormItem label="账号" prop="name">
                <Input v-model="phoneForm.name" :disabled="true"></Input>
              </FormItem>
              <FormItem label="新密码" prop="password">
                <Input v-model="passwordForm.password" type="password"></Input>
              </FormItem>
              <FormItem label="确认密码" prop="confirmPassword">
                <Input v-model="passwordForm.confirmPassword" type="password"></Input>
              </FormItem>
            </Form>
            <div style="text-align:right">
              <Button type="primary" @click="next">下一步</Button>
            </div>
          </div>
          <!-- <div v-if="current==1" style="font-size: 14px;text-align:center;">
            <img src="../images/成功.png" width="40" height="40" style="vertical-align: middle;margin-right:16px;">
            <span>注册成功！</span>
            <a href="javascript:void(0)" @click="goLogin">返回登录>></a>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import ajax from '@/lib/userAjax.ts'
import util from "../lib/util"

export default {
  name: 'forgetPwd',
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else if (value.length < 6) {
        callback(new Error('密码不少于6位'))
      } else {
        if (this.$refs.passwordForm.confirmPassword !== '') {
          this.$refs.passwordForm.validateField('confirmPassword')
        }
        callback()
      }
    }
    const validateConfirmpwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入确认密码'))
      } else if (value !== this.passwordForm.password) {
        callback(new Error('确认密码与密码不一致'))
      } else {
        callback()
      }
    }
    return {
      current: 0,
      phoneForm: {
        name: this.$store.state.session.user.userName,
        phone: this.$store.state.session.user.phoneNumber,
        mail: this.$store.state.session.user.emailAddress,
        validateNum: ''
      },
      passwordForm: {
        password: '',
        confirmPassword: ''
      },
      phoneValidate: {
        name: [
          { required: true, message: '请输入会员账号', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { type: 'string', pattern: /1[0-9]{10}$/, message: '请检查您输入的号码', trigger: 'blur' }
        ],
        mail: [
          { required: true, message: '请输入账号邮箱' },
          { type: 'email', message: '请输入正确的邮箱' }
        ],
        validateNum: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { type: 'string', pattern: /^\d{6}$/, message: '验证码格式错误', trigger: 'blur' }
        ]
      },
      passwordValidate: {
        password: [
          { validator: validatePass, trigger: 'change' }
        ],
        confirmPassword: [
          { validator: validateConfirmpwd, trigger: 'change' }
        ]
      },
      validMode: 'phone',
      codeCount: 60,
      codeDisabled: false,
      codeValidText: '获取验证码',
      validCode: 0,
      getVercodeNum: '',
      codeInterval: '',
      userId: 0
    }
  },
  methods: {
    next() {
      // if (this.current === 0) {
      //   this.$refs.phoneForm.validate(async (valid) => {
      //     if (valid) {
      //       // 验证码校验
      //       let ValidCode = '000000' + this.validCode * 1717
      //       ValidCode = ValidCode.slice(-6)
      //       if (this.validMode === 'phone') {
      //         if (this.phoneForm.phone !== this.getVercodeNum || this.phoneForm.validateNum !== ValidCode) {
      //           this.$Message.error('验证码不正确')
      //           return
      //         }
      //       }
      //       if (this.validMode === 'mail') {
      //         if (this.phoneForm.mail !== this.getVercodeNum || this.phoneForm.validateNum !== ValidCode) {
      //           this.$Message.error('验证码不正确')
      //           return
      //         }
      //       }
      //       // 发送修改密码通知
      //       let rep = await ajax.post('/api/services/app/Account/SendPasswordResetCode', {
      //         username: this.phoneForm.name,
      //         phoneOrEmail: this.getVercodeNum,
      //         resetCode: this.validCode * 171717
      //       })
      //       if (rep.data.success) {
      //         this.userId = rep.data.result.id
      //         this.current = 1
      //       }
      //     }
      //   })
      // }
      if (this.current === 0) {
        this.$refs.passwordForm.validate(async (valid) => {
          if (valid) {
            // 发送更改密码操作
            let resetRep = await ajax.post('/api/services/app/Account/UserResetPassword', {
              // userId: this.userId,
              // resetCode: this.validCode * 171717,
              userName: this.phoneForm.name,
              password: this.passwordForm.password
            })
            if (resetRep.data.success) {
              // this.current = 2
              this.$Modal.success({
                title: '提示',
                content: '密码修改成功，按确定重新登录',
                onOk: () => {
                  this.$store.commit("app/logout", this)
                  util.abp.auth.clearToken()
                  setTimeout(() => {
                    window.location.href = 'http://qy.chinapsp.cn:8884'
                  }, 1000)
                }
              })
            }
          }
        })
      }
    },
    goLogin() {
      this.$router.push({ name: 'login' })
    },
    getVercode() {
      if (this.validMode === 'phone') {
        this.$refs.phoneForm.validateField('phone', async valid => {
          if (!valid) {
            this.validCount()
            this.validCode = this.getValidCode()
            this.getVercodeNum = this.phoneForm.phone
            let phoneRep = await axios.get('https://wx.chinapsp.cn/api3/phoneValidate', {
              params: {
                phone: this.phoneForm.phone,
                validateCode: this.validCode
              }
            })
            if (phoneRep.data.message === '请勿重复发送') {
              this.$Message.success('发送过于频繁，请一分钟后再尝试')
            }
          }
        })
      }
      if (this.validMode === 'mail') {
        this.$refs.phoneForm.validateField('mail', async valid => {
          if (!valid) {
            this.validCount()
            this.validCode = this.getValidCode()
            this.getVercodeNum = this.phoneForm.mail
            let mailRep = await axios.get('https://wx.chinapsp.cn/api3/mailValidate', {
              params: {
                toMail: this.phoneForm.mail,
                validateCode: this.validCode
              }
            })
            if (mailRep.data.message === '请勿重复发送') {
              this.$Message.success('发送过于频繁，请一分钟后再尝试')
            }
          }
        })
      }
    },
    getValidCode() {
      const num = '0123456789'
      let resultNum = ''
      let time = 6
      while (time--) {
        resultNum += num[Math.floor(Math.random() * 10)]
      }
      return resultNum
    },
    validCount(type) {
      this.codeDisabled = true
      this.codeInterval = setInterval(() => {
        this.codeCount--
        if (this.codeCount > 0) {
          this.codeValidText = `重新获取(${this.codeCount})`
        } else {
          clearInterval(this.codeInterval)
          this.codeValidText = `获取手机验证码`
          this.codeDisabled = false
          this.codeCount = 60
        }
      }, 1000)
    }
  }
}
</script>

<style lang="less" scope>
.container {
  height: 100%;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  min-height: 100%;
  background: #f0f2f5;
}
@media (min-width: 768px) {
  .container {
    background-image: url(https://gw.alipayobjects.com/zos/rmsportal/TVYTbAXWheQpRcWDaDMu.svg);
    background-repeat: no-repeat;
    background-position: center 110px;
    background-size: 100%;
    font-size: 18px;
  }
  .content {
    padding: 112px 0 24px;
  }
}
.content {
  height: 100%;
  padding: 32px 0;
  -ms-flex: 1 1 0%;
  flex: 1 1 0%;
  overflow: auto;
}
.wrapper {
  width: 500px;
  margin: 0 auto;
  .content-wrapper {
    margin-top: 50px;
  }
}
// 修改步骤条样式
#forgetPwd {
  .ivu-steps .ivu-steps-head,
  .ivu-steps .ivu-steps-title,
  .ivu-steps-item.ivu-steps-status-wait .ivu-steps-head-inner,
  .ivu-steps-item.ivu-steps-status-finish .ivu-steps-head-inner {
    background: rgb(240, 242, 245) !important;
  }
  .ivu-steps .ivu-steps-title {
    margin-top: 4px;
  }
  .ivu-input[disabled],
  fieldset[disabled] .ivu-input {
    color: #515a6e !important;
  }
  .switch {
    padding: 5px 0;
    font-size: 14px;
    color: #5cadff;
    cursor: pointer;
    text-align: right;
  }
}
</style>
